import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { useAuth } from "../contexts/auth.context";
import { getReturnUrlFromLocalStorage, setReturnUrlFromLocalStorage, getTokenFromLocalStorage, setTokenToLocalStorage, setUserToLocalStorage, tokenHasExpired, } from "../services/localStorage/localStorageService";
import Login from "./Login";
import { convertToPath } from "../general/utils";
import { env } from "../variables/config";
import { confirmAuthorised } from "../services/auth/authService";
import { LoginIcon, RegisterIcon } from "../general/Icons";
import ProfileDropdown from "./ProfileDropdown";
const assumeProduction = () => {
    console.warn("Error fetching environment. Assuming production.");
    return "production";
};
const fetchEnvironment = () => {
    return fetch(env.API_PATH + "/system/environment")
        .then((res) => {
        if (res.ok) {
            return res.json();
        }
        return null;
    })
        .then((res) => {
        if (!res?.environment) {
            return assumeProduction();
        }
        return res.environment;
    })
        .catch(() => {
        return assumeProduction();
    });
};
const getBackgroundClass = (environment) => {
    if (environment.startsWith("review"))
        return "bg-danger";
    switch (environment) {
        case "dev":
        case "testing":
        case "qa":
            return "bg-danger";
        case "staging":
            return "bg-success";
        default:
            return "";
    }
};
// on page change update returnUrl to page route
function Navigation(props) {
    const { setToken, user, setUser } = useAuth();
    const [environment, setEnvironment] = useState("");
    useEffect(() => {
        fetchEnvironment().then((fetchedEnvironment) => {
            setEnvironment(fetchedEnvironment);
        });
    }, []);
    const isProduction = () => {
        return environment === "production";
    };
    const revokeOicd = (token) => {
        fetch(env.API_PATH + "/auth/logout", {
            body: JSON.stringify({ token: token }),
            method: "POST",
            headers: { "Content-Type": "application/json" },
        });
    };
    const logout = () => {
        setReturnUrlFromLocalStorage(window.location.pathname);
        const token = getTokenFromLocalStorage();
        if (token)
            revokeOicd(token);
        setTokenToLocalStorage("");
        setUserToLocalStorage(null);
        setToken("");
        setUser(null);
    };
    const addPage = (page) => {
        if (!page.hidden) {
            const authorised = confirmAuthorised(user, page.auth, page.removeOnAuth);
            if (authorised) {
                return (_jsx(Nav.Link, { href: convertToPath(page.name), children: page.name }, page.name));
            }
        }
    };
    const addDropdown = (dropdown) => {
        if (!dropdown.hidden) {
            const authorised = confirmAuthorised(user, dropdown.auth, dropdown.removeOnAuth);
            if (authorised) {
                return (_jsx(NavDropdown, { title: dropdown.name, children: dropdown.pages &&
                        dropdown.pages.map((page, index) => {
                            return (
                            // eslint-disable-next-line
                            _jsx("div", { className: "nav-dropdown-box", children: _jsx(Nav.Link, { href: convertToPath(dropdown.name) + convertToPath(page.name), children: page.name }, page.name) }, index));
                        }) }));
            }
        }
    };
    return (_jsx("div", { className: "navigation", children: _jsx(Navbar, { className: "navbar-dark " + getBackgroundClass(environment) +
                " navbar-custom fixed-top", expand: "lg", children: _jsxs(Container, { children: [_jsxs(Navbar.Brand, { href: "/", children: [props.brand, environment && !isProduction() && " " + environment] }), _jsx(Navbar.Toggle, { "aria-controls": "basic-navbar-nav" }), _jsxs(Navbar.Collapse, { id: "basic-navbar-nav", children: [props.pages.map((page, index) => {
                                // @ts-ignore
                                if (page.pages !== undefined) {
                                    return _jsx("span", { children: addDropdown(page) }, index);
                                }
                                else {
                                    return _jsx("span", { children: addPage(page) }, index);
                                }
                            }), props.register && tokenHasExpired() ? (_jsx(Nav.Link, { className: "nav-right", children: _jsx(Login, { buttonIcon: RegisterIcon, returnUrl: props.customCallbackUrl ?? "/" }) }, "Register")) : null, props.login && tokenHasExpired() ? (_jsx(Nav.Link, { className: !props.register ? "nav-right" : "", children: _jsx(Login, { buttonIcon: LoginIcon, returnUrl: getReturnUrlFromLocalStorage() }) }, "Login")) : user ? (_jsx("div", { className: "nav-right", children: _jsx(ProfileDropdown, { user: user, pages: props.profilePages, onLogout: logout }) })) : null] })] }) }) }));
}
//@ts-ignore
export default withRouter(Navigation);
